/* ==== components/admin/DocumentsTypeForm.js  ==== */
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
  DialogActions,
} from "@mui/material";

const schema = yup.object().shape({
  doctip: yup.string().required("El nombre del tipo de documento es obligatorio"),
  docdes: yup.string().max(255, "Máximo 255 caracteres"),
});

const DocumentsTypeForm = ({ open, handleClose, onSubmit, defaultValues = {} }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues,
  });

  // Resetear el formulario cuando cambia `defaultValues` o se cierra el modal
  useEffect(() => {
    if (open) {
      reset(defaultValues);
    }
  }, [open, defaultValues, reset]);

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>{defaultValues?.doctipid ? "Editar Tipo de Documento" : "Crear Tipo de Documento"}</DialogTitle>
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogContent>
          {/* Nombre del Tipo de Documento */}
          <TextField
            label="Nombre del Tipo de Documento"
            fullWidth
            margin="normal"
            {...register("doctip")}
            error={!!errors.doctip}
            helperText={errors.doctip?.message}
          />

          {/* Descripción (Opcional) */}
          <TextField
            label="Descripción"
            fullWidth
            margin="normal"
            {...register("docdes")}
            error={!!errors.docdes}
            helperText={errors.docdes?.message}
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button type="submit" variant="contained">
            {defaultValues?.doctipid ? "Actualizar" : "Guardar"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default DocumentsTypeForm;
